import React, { useEffect, useState } from "react";
import "./Blog.css";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🔹 Replace with your API endpoint
  const API_URL = "https://apiwebsite.paushtikkswitch.com/api/Masters/GetBlogs";

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(API_URL);
        const data = await response.json();
        setBlogs(data); // expects array of { image, title, category, subtitle }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching blogs:", error);
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section className="heronew" style={{ background: "white" }}>
        <img
          src="img/blogleft.png"
          className="vectorall-left desktopvector"
          alt="left vector"
        />
        <img
          src="img/m2.png"
          className="vectorall-left mobilevector"
          alt="left vector"
        />

        <div className="hero-content">
          <h1 className="headline">
            <span style={{ color: "#2F2F2F" }}>Eat Better. Live Better</span>
          </h1>
          <p className="subehad">
            Our blog shares everything you need to know about nutrition,
            wellness, and staying consistent with your goals.
          </p>
        </div>
        <img
          src="img/blogright.png"
          className="vectorabout-right"
          alt="right vector"
        />
      </section>

    {/* Featured Blog (Dynamic from API) */}
<section className="about-section1">
  <div className="blog-section">
    {loading ? (
      <p>Loading featured blog...</p>
    ) : blogs.length > 0 ? (
      <>
        {/* Desktop Featured Blog */}
        <div className="featured-blog desktopview">
          <img src={blogs[0].imagesfile} alt={blogs[0].heading} />
          <div className="featured-content">
            <span className="featured-badge">TRENDING</span>
            <br />
            <br />
            <h3>{blogs[0].heading}</h3>
            <p>{blogs[0].description}</p>
          </div>
        </div>

        {/* Mobile Featured Blog */}
        <div className="blog-grid mobileview">
          <h3 className="all-blogs-heading">TRENDING</h3>
          <div className="blog-card">
            <img src={blogs[0].imagesfile} alt={blogs[0].heading} />
            <div className="card-overlay">
              <span className="badge">{blogs[0].subHeading}</span>
              <h4>{blogs[0].heading}</h4>
              <h6>{blogs[0].description}</h6>
            </div>
          </div>
        </div>
      </>
    ) : (
      <p>No blogs available</p>
    )}
  </div>
</section>


   {/* All Blogs (Dynamic from API) */}
<section className="about-section1">
  <div className="blog-section">
    <h3 className="all-blogs-heading">All Blogs</h3>

    {loading ? (
      <p>Loading blogs...</p>
    ) : (
      <div className="blog-grid">
        {blogs.map((blog, index) => (
          <div
            className="blog-card"
            key={index}
            onClick={() => window.open(blog.redirecturl, "_blank")} 
            style={{ cursor: "pointer" }}
          >
            <div className="social-gradient-overlay"></div>
            <img src={blog.imagesfile} alt={blog.heading} />
            <div className="card-overlay">
              <span className="badge">{blog.subHeading}</span>
              <h4>{blog.heading}</h4>
              <h6>{blog.description}</h6>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
</section>

    </div>
  );
};

export default Blog;
